import React from 'react';

const NotFound = () => {
    return (
        <div className={'col-12 px-0 text-center'}>
            <h1>Page not found</h1>
        </div>
    );
}

export default NotFound;